export default __webpack_public_path__ + "static/media/hht2_img_title.9fe1a786.png";